// src/components/Article/DocumentSummaryAccordion.jsx
import React, { useState } from 'react';
import { ChevronDown, ChevronUp, FileText, Copy, Check } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

const DocumentSummaryAccordion = ({ doc, t }) => {
  const [open, setOpen] = useState(false);
  const [hasCopiedSummary, sethasCopiedSummary] = useState(false);
  

  const handleCopySummary = async () => {
      try {
        await navigator.clipboard.writeText(doc.document_summary || '');
        sethasCopiedSummary(true);
        setTimeout(() => sethasCopiedSummary(false), 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    };

  return (
    <div className="border border-gray-200 rounded-md overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 transition-colors"
      >
        <div className="flex items-center gap-2 text-sm font-medium text-brand-dark">
          <FileText className="w-4 h-4 text-brand-orange" />
          <span className="truncate max-w-xs">{doc.original_filename}</span>
        </div>
        <div className="flex items-center gap-4 text-xs text-gray-500">
          {doc.num_pages && <span>{doc.num_pages} {t('articleGenerator.pages')}</span>}
          {doc.num_chunks && <span>{doc.num_chunks} {t('articleGenerator.chunks')}</span>}
          {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </div>
      </button>

      {open && doc.document_summary && (
        <div className="relative p-4 bg-white border-t border-gray-200">
          <button
            onClick={handleCopySummary}
            className="absolute top-2 right-2 p-1.5 bg-slate-200 hover:bg-brand-orange rounded-md transition-colors"
            title={t('articleGenerator.copySummary')}
          >
            {hasCopiedSummary ? (
              <Check size={16} className="text-green-400" />
            ) : (
              <Copy size={16} className="text-gray-600" />
            )}
          </button>
          <div className="prose prose-sm max-w-none text-brand-dark">
          <ReactMarkdown>
            {doc.document_summary}
          </ReactMarkdown>
          </div>
        </div>
      )}

      {open && !doc.document_summary && (
        <div className="p-4 bg-white border-t border-gray-200 text-sm text-gray-500">
          {t('articleGenerator.noSummary')}
        </div>
      )}
    </div>
  );
};

export default DocumentSummaryAccordion;